import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "./components/Nav";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { WhoWeHelp } from "./components/WhoWeHelp";
import { HowItWorks } from "./components/HowItWorks";
import { CaseStudies } from "./components/CaseStudies";
import { Testimonials } from "./components/Testimonials";
import { Pricing } from "./components/Pricing";
import { Faq } from "./components/Faq";
import { BookCalendar } from "./components/BookCalendar";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { ChatWidget } from "./components/ChatWidget";
import Admin from "./pages/Admin";

const Landing = () => (
  <div className="App" data-testid="app-root">
    <PromoBar />
    <Nav />
    <main>
      <Hero />
      <Services />
      <WhoWeHelp />
      <HowItWorks />
      <CaseStudies />
      <Testimonials />
      <Pricing />
      <Faq />
      <BookCalendar />
      <Contact />
    </main>
    <Footer />
    <ChatWidget />
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          border: "2px solid #1c1917",
          borderRadius: "16px",
          boxShadow: "4px 4px 0 0 #1c1917",
          fontFamily: "Figtree, sans-serif",
          fontWeight: 600,
        },
      }}
    />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
